import type { DcaScenariosResponse } from 'types/api-responses';

/**
 * The id to save for a scenario. Null for none, and for the DCA scenario
 * selector's "Legacy" options, whose ids are not scenario ids.
 *
 * @param {DcaScenariosResponse | null} scenario - The selected scenario.
 * @return {number | null} The scenario id, or null.
 */
export const savedDcaScenarioId = (
  scenario: DcaScenariosResponse | null
): number | null => (typeof scenario?.id === 'number' ? scenario.id : null);
